import { NS_CONFIGURATION, PROJECT, EDITOR, GENERAL } from 'redux/constants';
import { action, createType, SYNC, ASYNC } from 'redux-create-type';
import * as _fieldset from './fieldset/actions';

export const fieldset = _fieldset;

export const {
  INIT,
  SET_TAB,
  SAVE,
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, GENERAL)({
    INIT: SYNC,
    SET_TAB: SYNC,
    SAVE,
  });

export const init = ({ projectId }) => action(INIT, { projectId });

export const setTab = (value, setUrl = true) => action(SET_TAB, { value, setUrl });
export const save = ({
    projectId,
    name,
    startDate,
    description,
    companyId,
    isActive,
    workingDayInherit,
    workingTimings,
    estimationUnit,
    costOfEstimationUnit,
    projectType
  }) => action(SAVE, {
      projectId,
      name,
      startDate,
      description,
      companyId,
      isActive,
      workingDayInherit,
      workingTimings,
      estimationUnit,
      costOfEstimationUnit,
      projectType
    });



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/general/actions.js